import * as types from './constants';

// Withdraw Unmasking Invitation
export const withdrawUnmaskingInvitationRequest = data => (
  { type: types.WITHDRAW_UNMASKING_INVITATION_REQUEST, payload: data }
);

export const withdrawUnmaskingInvitationDone = data => (
  { type: types.WITHDRAW_UNMASKING_INVITATION_DONE, payload: data }
);

export const withdrawUnmaskingInvitationFailed = errors => (
  { type: types.WITHDRAW_UNMASKING_INVITATION_FAILED, payload: errors }
);